import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const GrantAccessIconv2 = (props: SvgProps) => (
  <Svg
    width={168}
    height={249}
    fill="none"
    {...props}
  >
    <Path
      stroke="#BF643D"
      strokeWidth={1.5}
      d="M126.5 1c73.5 45.5 44 268.5-73.5 210s31-185.5 7.5-58.5c-7.207 38.946-30.513 70.516-60 95.374"
    />
  </Svg>
)
export default GrantAccessIconv2
